import axios from '../../axios';

// Recupera la lista degli insegnanti
export const fetchTeachers = async () => {
    try {
        const response = await axios.get('/anagrafiche/corsi-caricati', { withCredentials: true });
        let teachers = response.data || [];
        teachers.sort((a, b) => {
            const nameA = a.CognomeMT ? String(a.CognomeMT).toUpperCase() : '';
            const nameB = b.CognomeMT ? String(b.CognomeMT).toUpperCase() : '';
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
        });
        return teachers;
    } catch (error) {
        console.error('Errore nel recupero degli insegnanti', error);
        throw error;
    }
};

// Recupera i corsi di un insegnante
export const fetchCoursesByTeacher = async (teacherId) => {
    try {
        const response = await axios.get(`/anagrafiche/dettagli-corsi-caricati?user_id=${teacherId}`, {
            withCredentials: true
        });
        return response.data || [];
    } catch (error) {
        console.error('Errore nel recupero dei corsi', error);
        throw error;
    }
};

// Recupera le lezioni di un corso
export const fetchLezioniByCorso = async (idCorso) => {
    try {
        const token = localStorage.getItem('token');
        const idNum = Number(idCorso);
        if (!Number.isFinite(idNum)) {
            console.warn('fetchLezioniByCorso called with invalid idCorso:', idCorso);
            return [];
        }

        const payload = { token, idCorso: idNum };
        console.debug('fetchLezioniByCorso payload:', payload);
        const response = await axios.post('/datahandler/get-corso-lezioni', payload);
        return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
        console.error('Errore nel recupero delle lezioni', error);
        throw error;
    }
};

// Aggiunge una lezione al corso
export const addLezioneToCorso = async (idCorso, progrLezione) => {
    try {
        const token = localStorage.getItem('token');
        const idNum = Number(idCorso);
        if (!Number.isFinite(idNum)) {
            console.warn('addLezioneToCorso called with invalid idCorso:', idCorso);
            throw new Error('idCorso non valido');
        }

        const payload = {
            token,
            idCorso: idNum,
            progr_lezione: progrLezione,
            stato: 0
        };
        console.debug('addLezioneToCorso payload:', payload);
        const response = await axios.post('/datahandler/add-lezione-admin', payload);
        return response.data;
    } catch (error) {
        console.error('Errore durante l\'aggiunta della lezione', error);
        throw error;
    }
};
